const cancerAr = [
    "Lung Cancer",
    "Breast Cancer",
    "Prostate Cancer",
    "Colorectal Cancer",
    "Leukemia",
    "Lymphoma",
    "Melanoma",
    "Pancreatic Cancer",
    "Ovarian Cancer",
    "Esophageal Cancer",
    "Liver Cancer",
    "Bladder Cancer",
    "Thyroid Cancer",
    "Cervical Cancer",
    "Endometrial Cancer",
    "Testicular Cancer",
    "Gastric Cancer",
    "Kidney (Renal) Cancer",
    "Brain Tumor",
    "Multiple Myeloma",
    "Oral Cancer",
    "Nasopharyngeal Cancer",
    "Uterine Cancer",
    "Adrenocortical Carcinoma",
    "Sarcoma",
    "Wilms Tumor",
    "Retinoblastoma",
    "Neuroblastoma",
    "Hodgkin Lymphoma",
    "Mesothelioma",
    "Chronic Myeloid Leukemia (CML)",
    "Chronic Lymphocytic Leukemia (CLL)",
    "Thymoma",
    "Germ Cell Tumors",
]

const cancers = cancerAr.reduce((accumulator, disease) => {
    accumulator.push({category: 'Cancer', disease})
    return accumulator
}, [])

export default cancers